import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { Title, BackLink } from '../components'
import { GroupForm } from '../forms'
import { editGroup, loadGroup, createGroup, clearGroup } from '../../common/groups/actions'

class GroupFormPage extends React.Component {
  componentWillMount() {
    const { loadGroup } = this.props
    const path = location.pathname
    this.groupID = 0
    if (path.includes('edit')) {
      this.groupID = path.substring(path.lastIndexOf('/') + 1)
      loadGroup(this.groupID)
    }
  }

  componentWillUnmount() {
    this.props.clearGroup()
  }

  render() {
    const { currentGroup, editGroup, createGroup, intl } = this.props

    if (this.groupID) {
      if (currentGroup && currentGroup.id === this.groupID) {
        return (
          <div>
            <Title message="Edit group" />
            <BackLink />
            <GroupForm
              submitGroup={editGroup}
              group={currentGroup}
            />
          </div>
        )
      }
      return null
    }
    return (
      <div>
        <Title message="Create new group" />
        <BackLink />
        <GroupForm
          submitGroup={createGroup}
          label={intl.formatMessage(messages.className)}
          nameAsPopup
        />
      </div>
    )
  }
}

GroupFormPage.defaultProps = {
  editGroup: null,
  viewer: null,
  currentGroup: null,
}

GroupFormPage.propTypes = {
  intl: PropTypes.object.isRequired,
  currentGroup: PropTypes.object,
  editGroup: PropTypes.func.isRequired,
  createGroup: PropTypes.func.isRequired,
  loadGroup: PropTypes.func.isRequired,
  clearGroup: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    currentGroup: state.groups.currentGroup,
  }), { editGroup, loadGroup, createGroup, clearGroup }),
  injectIntl,
)

export default enhance(GroupFormPage)

const messages = defineMessages({
  className: {
    id: 'groupForm.page.className',
    defaultMessage: 'Názov triedy',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/GroupFormPage.js